import cx from "classnames"
import PropTypes from "prop-types"
import AuthorAvatars from "components/AuthorAvatars"
import playIcon from "./play-icon.svg"
import * as css from "./TutorialCard.module.css"

const DEFAULT_THUMBNAIL = "/images/tutorials/default-thumbnail.jpg"

function TutorialCard({
  title,
  author,
  category,
  duration,
  thumbnail,
  onClick,
  className,
}) {
  const formatDuration = (mins) => {
    if (!mins) return null
    if (mins < 60) return `${mins} min`
    const hours = Math.floor(mins / 60)
    const remainingMins = mins % 60
    return remainingMins > 0 ? `${hours}h ${remainingMins}m` : `${hours}h`
  }

  return (
    <div
      className={cx(css.root, className)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick?.()
        }
      }}
    >
      <div className={css.thumbnailWrapper}>
        <img
          src={thumbnail?.url || DEFAULT_THUMBNAIL}
          alt={thumbnail?.alt || title}
          className={css.thumbnail}
        />
        <div className={css.playOverlay}>
          <img src={playIcon} alt="Play video" className={css.playIcon} />
        </div>
        {duration && (
          <span className={css.duration}>{formatDuration(duration)}</span>
        )}
      </div>
      <div className={css.content}>
        {category && <span className={css.category}>{category}</span>}
        <h3 className={css.title}>{title}</h3>
        {author && (
          <div className={css.footer}>
            <AuthorAvatars author={author} size={24} />
          </div>
        )}
      </div>
    </div>
  )
}

TutorialCard.propTypes = {
  title: PropTypes.string.isRequired,
  author: PropTypes.string,
  category: PropTypes.string,
  duration: PropTypes.number,
  thumbnail: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default TutorialCard
